import { PropsWithChildren } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { queryClient } from '@/lib/react-query';
import { ErrorBoundary, ToastContainer } from '@/shared/components';
import { AuthProvider } from '@/core/auth/AuthContext';
import env from '@/core/config/env';

/**
 * AppProviders — wraps the entire application with all context providers
 */
export const AppProviders = ({ children }: PropsWithChildren) => {
    return (
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <AuthProvider>
                        {children}
                        <ToastContainer />
                    </AuthProvider>
                </BrowserRouter>
                {env.ENABLE_DEV_TOOLS && <ReactQueryDevtools initialIsOpen={false} />}
            </QueryClientProvider>
        </ErrorBoundary>
    );
};
